export const LabelMixin = {
    inject: {
        panel: {
            name: 'panel',
            default: null
        }
    },
    props: {
        prop: {
            type: String,
            default: ''
        }
    },
    computed: {
        hasPropName() {
            return this.prop !== '';
        },
        Label() {
            return this.hasPropName
                ? {
                    functional: true,
                    render: (h) => h('span', this.label)
                }
                : null;
        },
        Hint() {
            return this.hasPropName
                ? {
                    functional: true,
                    render: (h) => h('span', this.hint)
                }
                : null;
        },
        label() {
            if (this.hasPropName === false) {
                return '';
            }
            return this.panel?.getLabel(this.prop);
        },
        hint() {
            if (this.hasPropName === false) {
                return null;
            }
            return this.panel?.getHint(this.prop);
        },
        hasHint() {
            return this.hint != null || this.$scopedSlots.hint?.() != null;
        }
    },
    methods: {
        /**
         *
         * @param {string} propName
         * @return {string}
         */
        getLabel(propName) {
            return this.panel?.getLabel(propName);
        },
        /**
         *
         * @param {string} propName
         * @return {string}
         */
        getHint(propName) {
            return this.panel?.getHint(propName);
        }
    }
}
